import { PATIENT_REPORT_ISSUE_COPY } from '~/lib/constants/patientReport.constants';
import {
  TreatmentSummaryValidationItem,
  ValidateTreatmentSummaryRawResponse,
  ValidateTreatmentSummaryResponse,
} from '~/lib/types/patient/treatmentSummary';

const toDataIssue = (item: TreatmentSummaryValidationItem) => ({
  code: item.code,
  ...(PATIENT_REPORT_ISSUE_COPY[item.code] ?? {
    detail: item.message,
    label: item.message,
  }),
});

export const transformValidateResponse = (
  response: ValidateTreatmentSummaryRawResponse,
): ValidateTreatmentSummaryResponse => {
  // errors + warnings are treated identically downstream; "issue" reflects that both flow here.
  const apiIssues = [...response.errors, ...response.warnings];
  return {
    dataIssues: apiIssues.map(toDataIssue),
    issueCodes: apiIssues.map((i) => i.code),
  };
};
